import { render, staticRenderFns } from "./HeaderCategories.vue?vue&type=template&id=1eaf22f6&scoped=true&"
import script from "./HeaderCategories.vue?vue&type=script&lang=js&"
export * from "./HeaderCategories.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCategories.vue?vue&type=style&index=0&id=1eaf22f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaf22f6",
  null
  
)

export default component.exports